module.exports = __webpack_public_path__ + "img/Exchange_perspective_matte.ed94009c.png";